import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'

import * as state from '../../../../../../state'
import * as content from '../../../../content'

/**
 * Displays zone general information and permitted zone edit action.
 */
@ngCore.Component({
  imports: [
    ds.layout.widget.Component,
    ds.value.Component,
    content.admin.modals.zone.Component,
  ],
  selector: 'atn-admin-zone-page-general-tab',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.admin.zones.Collection} */
  public readonly zonesEc = ngCore.inject(state.admin.zones.Collection)

  /** @see {@link state.admin.contexts.Feature} */
  private readonly _contextsFeature = ngCore.inject(
    state.admin.contexts.Feature,
  )

  /** @see {@link state.me.Feature} */
  private readonly _meFeature = ngCore.inject(state.me.Feature)

  /** Currently selected zone */
  private readonly _zoneSg =
    this.zonesEc.plugins.currentEntityPlugin.feature.selectors.getEntity()
      .asSignal

  /** Currently selected zone name */
  public readonly nameSg = ngCore.computed(
    (zone = this._zoneSg()) => zone?.name,
  )

  /** Currently selected zone code */
  public readonly codeSg = ngCore.computed(
    (zone = this._zoneSg()) => zone?.code,
  )

  /** Currently selected zone alias */
  public readonly aliasSg = ngCore.computed(
    (zone = this._zoneSg()) => zone?.alias,
  )

  /** Currently selected zone description */
  public readonly descriptionSg = ngCore.computed(
    (zone = this._zoneSg()) => zone?.description,
  )

  /** Whether the current admin user can edit selected zone information */
  public readonly canEditZoneSg = ngCore.computed((zone = this._zoneSg()) =>
    state.admin.portalAccess.ContentActionAccess.canEditChild({
      context: this._contextsFeature.selectors.tenantContext.asSignal(),
      entity: zone,
      user: this._meFeature.selectors.currentUser.asSignal(),
    }),
  )

  /** Put selected zone in editing state */
  public editClickHandler(): void {
    const zone = this._zoneSg()
    if (zone) {
      this.zonesEc.plugins.editingPlugin.feature.actions.edit
        .from('AdminZone.GeneralTab.Edit.Icon.Clicked')
        .dispatch({
          id: zone.id,
        })
    }
  }
}
